import './alert.css'

const Alert = ({ type, message, children, onClose }) => {
    return (
        <div
            className={'alert ' + (type === 'success' ? 'alertSuccess' : 'alertError')}
            onClick={onClose}
            role="alert"
        >
            {children || message}
        </div>
    );
};

export default Alert;